import { render } from "./carditem.vue?vue&type=template&id=0fa838f9"
import script from "./carditem.vue?vue&type=script&lang=js"
export * from "./carditem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__